const API_BASE = '';


export function RegisterPage() {
  return `
<section class="max-w-6xl mx-auto py-12 px-4">
  <h1 class="text-3xl font-bold mb-8">Regístrese como asesor de certificación energética</h1>
  <div class="grid md:grid-cols-3 gap-8">
    
    <!-- Formulario -->
    <form id="registerForm" class="bg-white rounded-2xl shadow p-6 md:col-span-2">

      <!-- HONEYPOT FIELD -->
      <div style="position:absolute; left:-9999px; top:-9999px;">
        <input type="text" name="hp_field" tabindex="-1" autocomplete="off">
      </div>

      <!-- TIMESTAMP FIELD -->
      <input type="hidden" name="ts" id="ts">

      <div class="mb-4">
        <label class="block text-blue-700 font-semibold mb-1">Nombre de la empresa</label>
        <input type="text" name="company" required
          class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <div>
          <label class="block text-blue-700 font-semibold mb-1">Nombre</label>
          <input type="text" name="firstname" required
            class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
        </div>
        <div>
          <label class="block text-blue-700 font-semibold mb-1">Apellido</label>
          <input type="text" name="lastname" required
            class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
        </div>
      </div>

      <div class="mb-4">
        <label class="block text-blue-700 font-semibold mb-1">Correo electrónico</label>
        <input type="email" name="email" required
          class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
      </div>

      <div class="mb-6">
        <label class="block text-blue-700 font-semibold mb-1">Número de teléfono</label>
        <input type="tel" name="phone" required
          class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400">
      </div>

      <button type="submit"
        class="w-full bg-amber-500 hover:bg-amber-600 text-white font-semibold py-3 rounded-lg transition">
        Registrarse ahora
      </button>
    </form>

    <!-- Ventajas -->
    <aside class="bg-white rounded-2xl shadow p-6">
      <h3 class="text-lg font-semibold mb-4">Todos los beneficios</h3>
      <ul class="space-y-2 text-blue-700 font-medium">
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Más ingresos</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Herramientas HVAC</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Mayor alcance</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Cálculos de HVAC gratuitos</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Comodidad</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Valoración</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Conocimiento del mercado</a></li>
        <li class="flex items-center gap-2">✅ <a href="#" class="hover:underline">Encargos reales</a></li>
      </ul>
    </aside>
  </div>
</section>

  `;
}


export function initializeRegisterPage() {
  const form = document.getElementById("registerForm");
  if (!form) {
    setTimeout(initializeRegisterPage, 100);
    return;
  }

  // Zet timestamp zodra formulier in DOM staat
  const tsField = document.getElementById("ts");
  if (tsField) {
    tsField.value = Date.now();
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    // ✅ Submit-handler aangeroepen

    const data = Object.fromEntries(new FormData(form));

    try {
      const response = await fetch(`${API_BASE}/api/register_advisor`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (!response.ok) throw new Error(`Serverfout: ${response.status}`);

      const result = await response.json();

      if (result.success) {
        alert(`Bedankt voor je aanmelding, ${data.firstname}!`);
        form.reset();

        // Reset timestamp opnieuw na succesvol verzenden
        if (tsField) tsField.value = Date.now();
      } else {
        alert("Er ging iets mis bij het versturen van je gegevens. Probeer het later opnieuw.");
        console.error("❌ Backend error:", result.error);
      }
    } catch (err) {
      console.error("❌ Fout bij verzenden:", err);
      alert("Er ging iets mis bij het versturen van je gegevens. Probeer het later opnieuw.");
    }
  });
}